export const baseRequirementExceptions = {
  fetchAllBaseRequirements: "Error el obtener los requisitos base",
  fetchBaseRequirementByID:
    "Error al obtener el requisito base con determinado id",
  createBaseRequirement: "Error al crear un requisito base",
  updateBaseRequirementByID: "Error al actualizar un requisito base",
  addBaseRequirement: "Error al añadir un requisito base",
};
